//Redux Rlated Imports
import { createStore, applyMiddleware, compose, combineReducers } from "redux";
import thunk from "redux-thunk";

//My Reducers 
import * as pageReducers from './redux/page/pageReducers'
import * as footerReducers from './redux/footer/footerReducers'
import * as productReducers from './redux/product/productReducers'
import * as articelsReducers from './redux/article/articelsReducers'
import * as adminReducers from './redux/admin/adminReducers'
import * as commentReducers from './redux/comment/commentReducers'
import * as userReducers from "./redux/user/userReducers";
//From New Cart
import * as cartReducer from "./redux/cart/cartReducers";

const openSSModal = localStorage.getItem('openSSModal')
    ? JSON.parse(localStorage.getItem('openSSModal'))
    : false

const userInfoFromStorage = localStorage.getItem('userInfo')
    ? JSON.parse(localStorage.getItem('userInfo'))
    : null

const initialState = {
    openSSModalGlob: openSSModal,
    userLogin: { userInfo: userInfoFromStorage },
    cart: {
        reduxCartActionResult: null,
        reduxCartItems: JSON.parse(localStorage.getItem("localStoragecartItems") || "[]")
    }
}

const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(
    combineReducers({
        homePage: pageReducers.homePageReducers,
        aboutData: pageReducers.aboutPageReducers,
        contactData: pageReducers.contactPageReducers,
        contactMsg: pageReducers.sendContactReducers,
        footerData: footerReducers.footerSectionReducers,
        productList: productReducers.productListReducer,
        productDetails: productReducers.productDetailsReducer,
        adminProductDetail: productReducers.getDetailProductReducer,
        bookmaredProductsList: productReducers.bookmaredProductsListReducer,
        articelsList: articelsReducers.articlesListReducer,
        articleDetails: articelsReducers.articleDetailsReducer,
        adminArticleDetail: articelsReducers.adminArticleDetailsReducer,
        commentsList: commentReducers.commentListReducer,
        removeBookmark: userReducers.removeBookmarkReducer,
        userProfileImageUpdate: userReducers.userProfileImageUpdateReducer,
        profileInformation: userReducers.userProfileInformationReducer,
        profileUpdateRequest: userReducers.userProfileUpdateReducer,
        userProfilePasswordUpdate: userReducers.userProfilePasswordUpdateReducer,
        paidInvoicesList: userReducers.paidInvoicesListReducer,
        unpaidInvoicesList: userReducers.unPaidInvoicesListReducer,
        addBookmark: userReducers.addBookmarkReducer,
        userLogin: userReducers.userLoginReducer,
        userRegister: userReducers.userRegisterReducer,
        userConfirm: userReducers.userConfirmRegisterReducer,
        userCreate: userReducers.userCreatePasswordReducer,
        userRecovery: userReducers.userRecoveyReducer,
        cart: cartReducer.cartReducer,
        adminProfileInformation: adminReducers.adminProfileInformationReducer,

    }),
    initialState,
    composeEnhancer(applyMiddleware(thunk))
);


export default store